import { DatePicker as AntDatePicker, ConfigProvider } from 'antd'
import type { DatePickerProps } from 'antd'
import { Calendar } from 'lucide-react'

export function DatePicker({ className, format, ...props }: DatePickerProps) {
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorIcon: '#CE7A58',
                    colorTextQuaternary: '#000000',
                    colorTextPlaceholder: 'darkgray',
                },
                components: {
                    DatePicker: {
                        colorBgContainer: '#ffffff',
                        colorBgElevated: '#ffffff',
                    },
                },
            }}
        >
            <AntDatePicker
                className={['w-full rounded-full', className].filter(Boolean).join(' ')}
                format={format || "DD/MM/YYYY"}
                suffixIcon={<Calendar size={16} />}
                {...props}
            />
        </ConfigProvider>
    )
}